let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3VpLA")).then(() => parcelRequire('b6A6z'));